document.addEventListener('click', function (e) {
  var b = e.target.closest('[data-menu-toggle]');
  if (b) { document.querySelector('.hdr__nav').classList.toggle('hidden'); }
  var q = e.target.closest('[data-qty]');
  if (q && !q.closest('.pdp__buy')) {
    var input = q.parentElement.querySelector('input');
    var v = parseInt(input.value || '1', 10) + parseInt(q.dataset.qty, 10);
    input.value = v < 1 ? 1 : v;
    if (input.form) input.form.submit();
  }
});

/* Favoris — mémorisation locale */
document.addEventListener('click',function(e){
  var b=e.target.closest('.card__fav'); if(!b) return;
  e.preventDefault(); b.classList.toggle('is-on');
});